import {RoutesSignCode} from "./../models/route";
import {WayPointModel} from "../models/route";
import {AxiosPromise, AxiosResponse} from "axios";
import {HttpErrorModel} from "../../common/models/httpError";
import {PageableModel} from "../../common/models/table";
import http from "../../common/services/httpService";
import {Api, apiUrls, PaginationParams} from "../../helpers/api";
import {NewRouteModel, RouteDropDownModel, RouteModel} from "../models/route";

export class RouteService {
    private static baseUrl = apiUrls.topology.routes;

    public static async getAll(paginationParams: PaginationParams): Promise<AxiosResponse<PageableModel<RouteModel>>> {
        return await http.get<PageableModel<RouteModel>>(Api.addPaginationParams(Api.getUrl(this.baseUrl), paginationParams));
    }

    public static async getRoute(id: string): Promise<AxiosResponse<RouteModel>> {
        return await http.get(`${Api.getUrl(this.baseUrl)}/${id}`);
    }

    public static async activeOrInactiveRoute(id: string, active: boolean): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.patch(`${Api.getUrl(this.baseUrl)}/${id}/active`, {active});
    }

    public static async removeRoute(id: string): Promise<AxiosResponse> {
        return await http.delete(`${Api.getUrl(this.baseUrl)}/${id}`);
    }

    public static async addRoute(data: NewRouteModel): Promise<AxiosPromise> {
        return await http.post(Api.getUrl(this.baseUrl), data);
    }

    public static async modifyRoute(data: NewRouteModel, id: string): Promise<AxiosResponse<HttpErrorModel[]|any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/${id}`, data);
    }

    public static async getRouteForDropDown(): Promise<AxiosResponse<RouteDropDownModel[]>> {
        return await http.get(Api.getUrl(`${this.baseUrl}/dropdown`));
    }

    public static async getEntrance(id: string): Promise<AxiosResponse<WayPointModel>> {
        return await http.get(Api.getUrl(`${this.baseUrl}/${id}/way-point`));
    }

    public static async getSigns(): Promise<AxiosResponse<RoutesSignCode[]>> {
        return await http.get(Api.getUrl(`${this.baseUrl}/signs`));
    }
}
